import MTNSitcg from "./MTN-Sitcg";

export default MTNSitcg;
